if(!customElements.get('product-columns')) {
    class ProductColumns extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            this.swiperContainers = this.querySelectorAll('.swiper-container:not(.swiper-container--product-card)');
            if(this.swiperContainers.length > 0){
                this.initializeSwipers();
            }
        }

        async initializeSwipers() {
            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }
            
            this.swiperContainers.forEach(swiperContainer => {
                if(!swiperContainer) return;
                
                const slides = swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide--product-card)');
                if(slides.length <= 1) return;

                const itemsPerView = parseInt(swiperContainer.dataset.itemsPerView);
                const itemsPerViewMobile = parseInt(swiperContainer.dataset.itemsPerViewMobile);
                const totalSlides = parseInt(swiperContainer.dataset.itemsTotal);
                const autoplay = swiperContainer.dataset.autoplay === 'true';
                const speed = parseInt(swiperContainer.dataset.speed);
                const loop = swiperContainer.dataset.loop === 'true';
                const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
                const spaceBetween = parseInt(swiperContainer.dataset.gap);

                const breakpoints = {
                    0: { slidesPerView: itemsPerViewMobile },
                    768: { slidesPerView: visibleItemsPerView }
                }

                var swiperSettings = {
                    init: false,
                    initialSlide: 0,
                    loop: loop,
                    centeredSlides: false,
                    speed: 500,
                    watchOverflow: true,
                    breakpoints: breakpoints,
                    observer: true,
                    observeSlideChildren: true,
                    watchSlidesProgress: true,
                    autoHeight: false,
                    spaceBetween: spaceBetween,
                    on: {
                        init: () => {
                            const paginationBullets = swiperContainer.querySelectorAll(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet");
                            if(paginationBullets.length > 0){
                                this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                                paginationBullets.forEach((item, index) => {
                                    item.setAttribute('data-index', `${index}`);
                                });
                                setTimeout(() => {
                                    swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')?.classList.add('loaded');
                                    this.checkSwiperLock();
                                }, 500);
                            }
                        },
                        slideChange: () => {
                            const activePagination = swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                            if(activePagination){
                                const activePaginationIndex = parseInt(activePagination.dataset.index);
                                this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                            }
                        },
                        resize: () => {
                            const activePagination = swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                            if(activePagination){
                                const activePaginationIndex = parseInt(activePagination.dataset.index);
                                this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                            }
                        }
                    }
                }

                if(swiperContainer.querySelector(".swiper-navigation-wrapper:not(.swiper-navigation-wrapper--product-card)")){
                    swiperSettings.navigation = {
                        nextEl: swiperContainer?.querySelector('.button-next:not(.button-next--product-card)'),
                        prevEl: swiperContainer?.querySelector('.button-previous:not(.button-previous--product-card)')
                    }
                }

                if(swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')){
                    swiperSettings.pagination = {
                        el: swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')
                    }
                }

                if(autoplay && !isNaN(speed)){
                    swiperSettings.autoplay = {
                        delay: speed
                    }
                }

                const swiper = new Swiper(swiperContainer, swiperSettings);
                swiper.init();

                swiper.on("resize", this.checkSwiperLock.bind(this, swiperContainer, swiper));
            });

            this.setupFocusListeners();
        }

        checkSwiperLock(swiperContainer, swiper){
            if(!swiperContainer || !swiper) return;
            if(!swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)")) return;
            
            if(swiper.isLocked){
                swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.add('hidden');
            }else{
                swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next:not(.button-next--product-card), .button-previous:not(.button-previous--product-card)").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }
    
    customElements.define('product-columns', ProductColumns);
}